<template>
  <div :class="['switch-button',size]">
    <input id="switch-shadow" :class="['switch switch--shadow', checked ? 'checked' : '']" :disabled="disabled" @click="method" type="checkbox">
    <label for="switch-shadow" :style="'--color-not-checked:'+color[0]+'; --color-checked:'+color[1]" :class="[disabled ? 'not-allowed' : 'pointer']"></label>
  </div>
</template>

<script>
export default {
    name: 'switch-button',
    props: {
        color: {
            type: Array,
            required: false,
            default: ['#f1f1f1','#8ce196'],
            validator(value) {
                return value.length == 2;
            }
        },
        checked: {
            type: Boolean,
            default: false,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        method: {
            type: Function,
            required: true
        },
        size: {
            type: String,
            default: 'm',
            required: false,
            validator(value) {
                let options = ['s','m','l'];
                return options.indexOf(value) != -1;
            }
        }
    },
    data() {
        return {
        }
    },
}
</script>

<style lang="scss" scoped>
    .switch-button {
        padding-top: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .switch {
        visibility: hidden;
        position: absolute;
        margin-left: -9999px;
    }

    .switch + label {
        display: block;
        position: relative;
        outline: none;
        user-select: none;
    }
    .pointer {
        cursor: pointer;
    }
    .not-allowed{
        cursor: not-allowed;
    }
    .switch--shadow + label {
        padding: 2px;
        background-color: #dddddd;
        border-radius: 30px;
    }
    .s{
        .switch--shadow + label {
            width: 30px;
            height: 15px;
        }
        .switch--shadow + label:after {
            width: 12px;
            height: 13px;
            margin-top: 0.5px;
        }
        .checked + label:after {
            transform: translateX(16px);
        }
    }
    .m{
        .switch--shadow + label {
            width: 44px;
            height: 19px;
        }
        .switch--shadow + label:after {
            width: 15px;
            height: 16px;
            margin-top: 0.5px;
        }
        .checked + label:after {
            transform: translateX(27px);
        }
    }
    .l{
        .switch--shadow + label {
            width: 58px;
            height: 24px;
        }
        .switch--shadow + label:after {
            width: 21px;
            height: 21px;
        }
        .checked + label:after {
            transform: translateX(35px);
        }
    }
    .switch--shadow + label:before,
    .switch--shadow + label:after {
        display: block;
        position: absolute;
        top: 1px;
        left: 1px;
        bottom: 1px;
        content: "";
    }
    .switch--shadow + label:before {
        right: 1px;
        background-color: var(--color-not-checked);
        border-radius: 30px;
        transition: background 0.4s;
    }
    .switch--shadow + label:after {
        background-color: #fff;
        border-radius: 100%;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
        transition: all 0.4s;
    }
    .checked + label:before {
        background-color: var(--color-checked);
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/tools/switch/index.vue